<template>
<div class="home">
    <div class="map-container">
        <div id="map"></div>
    </div>
</div>
</template>

<script>
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'

export default {
    mounted () {
        mapboxgl.accessToken = 'pk.eyJ1IjoicHVzaGlhbiIsImEiOiJjaXdyaXptNDAweG1rMm90YmRnZHl0dDFpIn0.9kBN2eXNRe3uZ9VMoMhfhg'
        this.map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/pushian/cj8313byya3lp2so6gvh49efn', 
            center: [103.82740222, 1.2527583],
            zoom: 10
            // bounds: new mapboxgl.LngLatBounds([103.852152, 1.260704], [103.804682, 1.267034])
        })

        this.map.on('zoom', () => {
            console.log('zoom', this.map.getZoom())
        })

        this.map.on('load', () => {
            this.map.addLayer({
                "id": "tms-test",
                "type": "raster",
                'source': {
                   'type': 'raster',
                    'minzoom': 10,
                    'bounds': [103.804682, 1.236098, 103.852152, 1.267034],
                    'tiles': [
                        'https://aichongqing.oss-cn-hangzhou.aliyuncs.com/raster/{z}/{x}/{y}.png'
                    ]
                }
            })
        })
    }
}
</script>

<style lang="scss" scoped>
.home {
    height: 100vh;
    position: relative;
    overflow: hidden;
}

#map {
    width: 100%;
    height: 100vh;
    overflow: hidden;
}  
</style>